import React from 'react';
import axios from '../../helpers/axiosWebEntry';
import withContext from '../../hoc/withContext';
import ReactTable from 'react-table';


class Roster extends React.Component {

    state={
        rows:[]
    }

    loadRows = () => {
        this.props.context.showLoading();
        axios.get('/eventlistview?loadDisabled=true')
        .then(response => {
            this.setState({rows:response.data});
            this.props.context.hideLoading();
        })
        .catch(error=>{
            console.log(error);
            this.props.context.hideLoading();
        });
    }

    componentDidMount=()=>{
        this.props.context.setHeading('Data Views');
        this.loadRows();
    }

    render() {
        return (
            <div className="content-overlay">
                <ReactTable
                    data={this.state.rows}
                    minRows={0}
                    style={{height:'calc(100% - 200px)'}}
                    filterable
                    defaultFilterMethod={(filter, row, column) => {
                        const id = filter.pivotId || filter.id
                        return row[id] !== undefined ? String(row[id]).search(new RegExp(filter.value, 'i'))>-1 : true
                    }}
                    columns={
                        [
                            {accessor: 'id', show: false},
                            {Header:'Name', accessor: 'name'},
                        ]
                    }
                    getTdProps={(state, rowInfo, column, instance) => {
                        if(column.id!=='actions')
                            return {
                                onClick: (e, handleOriginal)=>{
                                    if (handleOriginal) {
                                        handleOriginal();
                                    }
                                    this.props.history.push(`/dataview/detail/${rowInfo.row.id}`);

                                },
                                style: {cursor: 'pointer'}
                            };
                        return {};
                    }}
                />
            </div>
        );
    }
}

export default withContext(Roster);